/**
 * Analyze the web forms in the funnel
 */
import { GOAL_WEB_FORM, GOAL_LANDING_PAGE_SUBMITTED } from '../../utils/editor.constants';

export const analyzeWebForms = (draftJson) => {
    const webFormCount = draftJson.cells.filter((cell) => cell.meta.type === GOAL_WEB_FORM).length;

    let message;
    let nameIcon;

    if (webFormCount === 0) {
        nameIcon = 'check-circle';
        message = 'funnel.unpublish.analysis.validation.webForms.none';
    } else if (webFormCount === 1) {
        nameIcon = 'alert-triangle';
        message = 'funnel.unpublish.analysis.validation.webForms.singular';
    } else {
        nameIcon = 'alert-triangle';
        message = 'funnel.unpublish.analysis.validation.webForms.plural';
    }

    const webFormAnalysis = {
        message,
        nameIcon,
        webFormCount,
    };

    return webFormAnalysis;
};

/**
 * Analyze the landing pages in the funnel
 */
export const analyzeLandingPages = (draftJson) => {
    const landingPageCount = draftJson.cells.filter((cell) => cell.meta.type === GOAL_LANDING_PAGE_SUBMITTED).length;

    let message;
    let nameIcon;

    if (landingPageCount === 0) {
        nameIcon = 'check-circle';
        message = 'funnel.unpublish.analysis.validation.landingPages.none';
    } else if (landingPageCount === 1) {
        nameIcon = 'alert-triangle';
        message = 'funnel.unpublish.analysis.validation.landingPages.singular';
    } else {
        nameIcon = 'alert-triangle';
        message = 'funnel.unpublish.analysis.validation.landingPages.plural';
    }

    const landingPageAnalysis = {
        message,
        nameIcon,
        landingPageCount,
    };

    return landingPageAnalysis;
};
